
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.706 12.944c0 .856-.742 1.556-1.647 1.556H2.47c-.906 0-1.648-.7-1.648-1.556V3.611h9.883v9.333zM2.471 5.167v7.777h6.588V5.167H2.47zm6.176-3.89h2.882v1.556H0V1.277h2.883L3.706.5h4.117l.824.777z","fill":"#585858"}})])
          )
        }
      }
    